<script setup>
import { onMounted } from 'vue';

const props = defineProps({
  compromisso: {
    required: true,
    type: Object,
  },
});

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions :column="3" :label-style="{ width: '20%' }" bordered>
    <a-descriptions-item label="Aprovado?" :span="3">
      {{ props.compromisso.data.aprovado ? 'SIM' : 'NÃO' }}
    </a-descriptions-item>

    <a-descriptions-item label="Observação" :span="3">
      {{ props.compromisso.data?.observacao }}
    </a-descriptions-item>
  </a-descriptions>
</template>
